<template>
  <div
    class="w-full bg-zt-white rounded-zt-md p-6"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center">
      <div
        class="mb-4 flex justify-center h-full"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : 'w-56']"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>

      <div class="w-full">
        <div class="mb-4" v-if="!changePasswordSuccess">
          <zt-alert
            :text="alertMessage"
            :color="errorPassword ? 'danger' : 'primary'"
            :closeIcon="false"
          >
            <div slot="icon">
              <div
                class="rounded-full w-24 h-24 flex justify-center items-center border-2 border-zt-primary-200"
                :class="{
                  'border-zt-danger': errorPassword,
                  'bg-zt-danger': errorPassword
                }"
              >
                <zt-icon
                  v-if="errorPassword"
                  class="text-5xl ml-px text-zt-white"
                  name="shield-asterisk"
                />
                <zt-icon
                  v-else
                  class="text-5xl mb-1"
                  name="exclamation-triangle"
                />
              </div>
            </div>
          </zt-alert>
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <div v-if="changePasswordSuccess">
            <ZTAuthPasswordExpiredSuccess
              :password-expired-custom-params-fields="boxLogin"
            />
          </div>
          <div v-else class="mx-auto mb-8 ">
            <ZTAuthPasswordExpiredFields
              v-model="passExpiredFields"
              :password-policies="passPolicies"
              :password-expired-custom-params-fields="boxLogin"
            />
            <div class="flex justify-end items-center">
              <router-link
                :to="{ name: 'login' }"
                class="mr-4 cursor-pointer"
                >{{
                  $t('message.loginComponent.passwordExpired.go_back_btn')
                }}</router-link
              >
              <zt-button
                :style="[bgButtonColor(invalid)]"
                :disabled="invalid"
                class="py-4 px-5"
                @click="changePasswordExpired"
                data-vs-button="auth-passwordexpired-btn-changepassexpired"
                >{{
                  $t('message.loginComponent.passwordExpired.update_pass_btn')
                }}</zt-button
              >
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import { mapGetters } from 'vuex'
import ZTAuthPasswordExpiredFields from '@/modules/Auth/components/authPasswordExpiredFields.vue'
import ZTAuthPasswordExpiredSuccess from '@/modules/Auth/components/authPasswordExpiredSuccess.vue'
import Company from '@/apiClient/Company'
import Users from '@/apiClient/Users'

export default {
  name: 'passwordExpired',
  components: {
    ZTAuthPasswordExpiredFields,
    ZTAuthPasswordExpiredSuccess
  },
  inject: ['storeUserPass'],
  data() {
    return {
      objectLoginParams: {},
      changePasswordSuccess: false,
      company: '',
      users: '',
      passPolicies: {},
      passExpiredFields: {
        password: '',
        rePassword: ''
      },
      errorPassword: false,
      errorCode: ''
    }
  },
  mixins: [loginCustomParams],
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams'
    }),
    bgButtonColor() {
      return invalid =>
        invalid
          ? { backgroundColor: '#E2E2E2' }
          : this.boxLogin.styles.form.buttons.bgColor
    },
    alertMessage() {
      let msg = this.$t(
        'message.loginComponent.passwordExpired.pass_expired_message'
      )

      if (this.errorCode !== '') {
        msg = this.$t(
          `message.loginComponent.passwordExpired.message_error.error_${this.errorCode}`
        )
      }
      return msg
    },
  },
  methods: {
    async changePasswordExpired() {
      this.errorPassword = false
      this.errorCode = ''
      let oldPass = this.storeUserPass.userPassExpired.p
      await this.users
        .changePassV2(
          oldPass,
          this.passExpiredFields.password,
          this.passExpiredFields.rePassword
        )
        .then(response => {
          if (response.status === 200) {
            this.changePasswordSuccess = true
          }
        })
        .catch(error => {
          this.errorPassword = true
          this.errorCode = error.response.data.codes[0].code
        })
    },
    async getPasswordPolicies() {
      await this.company
        .passwordPolicies()
        .then(response => {
          this.passPolicies = response.data
        })
        .catch(error => {})
    }
  },
  created() {
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
    this.company = new Company()
    this.users = new Users()
    this.getPasswordPolicies()
  }
}
</script>